import classnames from 'classnames';

// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { RichText } from "@wordpress/block-editor";
import styles from "./ThankYou.module.scss";

const ThankYou = ({ headline, description }) => {
  return (
    <div className={classnames(styles.wrapper, "typographyWrapper container my-4 py-3")}>
      <div className="gatewayFormContent">
        <h1>{headline}</h1>
        <p>{description}</p>
      </div>
    </div>
  );
};

// Block attributes (custom props)
const attributes = {
  headline: {
    type: 'string',
    default: "Get free legal advice"
  },
  description: {
    type: 'string',
    default: `See if we can help you protect and defend wildlife, people and places. For eligible applications,
our lawyers provide 15 minutes of free initial legal advice. Sometimes this initial advice will
progress to more detailed advice or legal representation. To understand how we use the information
we collect, and how the application process works, read “Our legal advice process”`
  },
}

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
  const { headline, description } = attributes;
  return (
    <Fragment>
      <ThankYou
        headline={<RichText
          value={headline}
          multiline={false}
          onChange={(headline) => setAttributes({ headline })}
          placeholder={__('Headline', 'hero')}
          allowedFormats={[]}
          keepPlaceholderOnFocus={true}
        />}
        description={<RichText
          value={description}
          multiline={true}
          onChange={(description) => setAttributes({ description })}
          placeholder={__('Description', 'hero')}
          // allowedFormats={[]}
          keepPlaceholderOnFocus={true}
        />} />
    </Fragment>
  );
}

// Edit function (responsible for wp-admin post edit screen)
const save = ({ setAttributes, attributes }) => {
  const { headline, description } = attributes;
  return <ThankYou headline={<RichText.Content value={headline} />} description={<RichText.Content value={description} />} />
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-form-thank-you", {

  /**
   * This is the display title for your block, which can be translated with `i18n` functions.
   * The block inserter will show this name.
   */
  title: __("Thank you", "gutenberg-form-thank-you"),

  /**
   * An icon property should be specified to make it easier to identify a block.
   * These can be any of WordPress’ Dashicons, or a custom svg element.
   */
  icon: "align-wide",

  /**
   * Blocks are grouped into categories to help users browse and discover them.
   * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
   */
  category: "widgets",

  /**
   * Optional block extended support features.
   */
  // supports: {
  //     // Removes support for an HTML mode.
  //     html: false
  // },
  attributes,

  /**
   * The edit function describes the structure of your block in the context of the editor.
   * This represents what the editor will render when the block is used.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
   *
   * @param {Object} [props] Properties passed from the editor.
   *
   * @return {WPElement} Element to render.
   */
  edit,

  /**
   * The save function defines the way in which the different attributes should be combined
   * into the final markup, which is then serialized by the block editor into `post_content`.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
   *
   * @return {WPElement} Element to render.
   */
  save
});
